
import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';
import { KeycloakService } from './keycloak.service';

export const httpTokenInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) =>
{
  const _keycloakService = inject(KeycloakService);
  return _keycloakService.addTokenToHeader(req.headers).pipe(
    mergeMap(headersWithBearer => {
      const kcReq = req.clone({ headers: headersWithBearer });
      return next(kcReq);
    })
  );
};